import { render, staticRenderFns } from "./PpnMasukan.vue?vue&type=template&id=2c97c262"
import script from "./PpnMasukan.vue?vue&type=script&lang=js"
export * from "./PpnMasukan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports